import displayPage from '@/layout/PageLayout'
import { getServerSideProps } from '@/modules/alt-all-docs/altAllDocs.props'

import AltAllDocs from '@/modules/alt-all-docs/AltAllDocs'

export { getServerSideProps }
export default displayPage(AltAllDocs)